<template>
    <Card class="card cursor-pointer" :title="office" titleClass="card-title fs-1 font-weight-900"  @click="handleStatPress">
        <template #cardToolbar>
            <div class="card p-4 flex-row justify-content-between d-flex back">
            <span class=" badge_size text-primary bg-white">
                {{formatNumber(total)}}
            </span>
            <div class="margin d-flex align-items-center">
                <h3>{{$t('expenses.expense')}}</h3>
            </div>
            </div>
        </template>
        <template #cardBody>
        <div class="d-flex justify-content-between gap-4">
            <div class="col card p-4 flex-row justify-content-between d-flex back">
            <span class=" badge_size text-danger bg-white">
                {{formatNumber(notValidated)}}
            </span>
            <div class="margin d-flex align-items-center">
                <h3>{{$t('expenses.status.notValidated')}}</h3>
            </div>
            </div>
            <div class="col card p-4 flex-row justify-content-between d-flex back">
            <span class=" badge_size text-success bg-white">
                {{formatNumber(validated)}}
            </span>
            <div class="margin d-flex align-items-center">
                <h3>{{$t('expenses.status.validated')}}</h3>
            </div>
            </div>
        </div>
        </template>
      <span  v-if="notApproved"
             class="position-absolute top-0 start-100 translate-middle font-size-h4  badge badge-lg badge-square badge-primary"
             :title="`${notApproved} ${$t('expenses.status.waitApprobation')}`"
        >
        {{ notApproved }}
      </span>
    </Card>
</template>

<script setup>
import Card from "@/components/Card.vue";
import { useFormatAmount } from "@/composables/formatAmount";
import { useRouter } from "vue-router";
import abilities from "@/composables/abilities";
import Button from "@/components/Button.vue";

const { formatNumber } = useFormatAmount()

const router = useRouter()

const props = defineProps({
    id: {type: String, default: ''},
    company: {type: String, default: ''},
    office: {type: String, default: 'Office 1'},
    total: {type: String, default: '10'},
    validated: {type: String, default: '5'},
    notValidated: {type: String, default: '5'},
    notApproved: {type: String, default: '5'},
})

function handleStatPress(){
    router.push({name: "office-users-expenses-overview", params:{id:props.id, company: props.company}})
}

</script>


<style scoped>
  .badge_size {
    width: 30px;
    height: 30px;
    border-radius: 5px;
    align-content: center;
    text-align: center;
    font-weight: bold;
  }
  .back {
    background-color: var(--bs-light-primary);
    border-radius: 8px;
    padding: 5px;
  }
  .margin{
    margin-left: 5px;
  }
 
</style>